// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__VIwT2","container":"styles_container__Y7auY","title":"styles_title__2IDsu","wrapper":"styles_wrapper__2CUNT","answer":"styles_answer__1LFKv"};